import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Chip from "@mui/material/Chip";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import CallMissedIcon from "@mui/icons-material/CallMissed";
import TableContainer from "@mui/material/TableContainer";
import AlertSnack from "./AlertSnack";
import server from "../../functions/server";
import MediaQuery from "react-responsive";
import { Box, Button, Paper, TextField } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { LoadingButton } from "@mui/lab";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Cookies from "js-cookie";

function preventDefault(event) {
  event.preventDefault();
}

function Orders(props) {
  const [openSnack, setOpenSnack] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [itens, setItens] = React.useState([]);
  const [nunota, setNunota] = React.useState();
  const [codparc, setCodparc] = React.useState();

  const openModal = () => {
    setOpenDialog(true);
  };

  const closeModal = () => {
    setOpenDialog(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    let selecionados = [];
    let serie_selec = [];

    data.forEach(function (value, codprod) {
      selecionados.push(codprod);
      serie_selec.push(value);
    });

    //window.alert(selecionados)

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + Cookies.get("bearer"),
      },
      body: new URLSearchParams({
        jsonid: localStorage.getItem("token"),
        nunota: nunota,
        codparc: codparc,
        codprod: selecionados,
        serie: serie_selec,
      }),
    };

    fetch(server + "insert/pedido_dev", options)
      .then((response) => response.json())
      .catch((err) => console.error(err));
  };

  let dados = props.dados;

  try {
    dados = JSON.parse(props.dados);
  } catch {
    return (
      <h2>
        Sua sessão expirou. Clique <a href="/portal">aqui</a> para logar
        novamente
      </h2>
    );
  }

  const downloadFile = (base64Data, fileName) => {
    const pdfContent = atob(base64Data);
    const byteArray = new Uint8Array(pdfContent.length);

    for (let i = 0; i < pdfContent.length; i++) {
      byteArray[i] = pdfContent.charCodeAt(i);
    }

    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const downloadLink = window.document.createElement("a");

    downloadLink.href = url;
    downloadLink.download = fileName;
    downloadLink.style.display = "none";
    window.document.body.appendChild(downloadLink);
    downloadLink.click();
    downloadLink.remove();

    window.URL.revokeObjectURL(url);
  };

  let cons_nota = async (nunota, nfse, servico) => {
    let url = server + "portalCliente/consulta/nfe";

    if (servico == true) {
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + Cookies.get("bearer"),
        },
        body: JSON.stringify({
          jsonid: localStorage.getItem("token"),
          nunota: `${nunota}`,
          nfse: `${nfse}`,
          servico: servico,
        }),
      })
        .then((resp) => resp.text())
        .then(function (reqres) {
          let resp = JSON.parse(reqres);
          downloadFile(resp.chave, `${nunota}.pdf`);
        })
        .catch(() => {
          window.alert("A sua sessão expirou");
          window.location.href = "/portal";
        });
    } else {
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + Cookies.get("bearer"),
        },
        body: JSON.stringify({
          jsonid: localStorage.getItem("token"),
          nunota: `${nunota}`,
          servico: servico,
        }),
      })
        .then((resp) => resp.text())
        .then(function (reqres) {
          let resp = JSON.parse(reqres);

          downloadFile(resp.chave, `${nunota}.pdf`);
        })
        .catch(() => {
          window.alert("A sua sessão expirou");
          window.location.href = "/portal";
        });
    }
  };

  let dados_novos = dados.filter((unico) => unico[4] == "NOTA");

  let notas = dados_novos.map((linha) => (
    <TableRow key={linha[1] + Math.floor(Math.random() * 100)}>
      <TableCell>{linha[0]}</TableCell>
      <TableCell>{linha[2]}</TableCell>
      <TableCell>{linha[3]}</TableCell>
      <TableCell align="right">
        <Tooltip title="Nota Fiscal" arrow>
          <IconButton
            onClick={() => cons_nota(linha[1], linha[9], false)}
            disabled={linha[9] ? true : false}
          >
            <PictureAsPdfIcon />
          </IconButton>
        </Tooltip>
      </TableCell>{" "}
      <TableCell align="right">
        <Tooltip title="Nota Fiscal de Serviço" arrow>
          <IconButton
            onClick={() => cons_nota(linha[1], linha[9], true)}
            disabled={linha[9] ? false : true}
          >
            <HomeRepairServiceIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  ));

  let notas_mobile = dados_novos.map((linha) => (
    <Paper sx={{ p: 3, display: "flex", flexDirection: "column", mb: 3 }}>
      <TableCell>
        <b>Nº Nota: </b>
        {linha[0]}
      </TableCell>
      <TableCell>
        <b>Data de Emissão: </b>
        {linha[2]}
      </TableCell>
      <TableCell>
        <b>Valor Total: </b>
        {linha[3]}
      </TableCell>
      <TableCell>
        <b>Ver Nota Fiscal: </b>
        <Tooltip title="Nota Fiscal" arrow>
          <IconButton
            onClick={() => cons_nota(linha[1], linha[9], false)}
            disabled={linha[9] ? true : false}
          >
            <PictureAsPdfIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
      <TableCell>
        <b>Ver Nota Fiscal de Serviço: </b>
        <Tooltip title="Nota Fiscal de Serviço" arrow>
          <IconButton
            onClick={() => cons_nota(linha[1], linha[9], true)}
            disabled={linha[9] ? false : true}
          >
            <HomeRepairServiceIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </Paper>
  ));

  const is_null = dados_novos.every((elemento) => elemento === null);

  return (
    <React.Fragment>
      <Dialog open={openDialog} onClose={() => closeModal()}>
        <DialogTitle>Selecione um item</DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            {itens == []
              ? null
              : itens.map((linha) => {
                  return (
                    <FormControlLabel
                      control={<Checkbox />}
                      label={
                        linha[2] +
                        (linha[5] == "           "
                          ? ""
                          : ", SÉRIE/LOTE: " + linha[5])
                      }
                      id={linha[0]}
                      name={linha[1]}
                      value={linha[5]}
                    />
                  );
                  //
                })}
          </DialogContent>
          <DialogActions>
            <Button loading onClick={() => closeModal()}>
              Cancelar
            </Button>
            <LoadingButton loading={loading} type="submit">
              OK
            </LoadingButton>
          </DialogActions>
        </form>
      </Dialog>
      <AlertSnack
        open={openSnack}
        tipo="error"
        texto="Erro: A Nota não está cadastrada no sistema."
        onClose={() => setOpenSnack(0)}
      />

      <MediaQuery orientation="landscape">
        <TableContainer>
          {!is_null ? (
            <Table size="small" xs={12}>
              <TableHead>
                <TableRow>
                  <TableCell>Nº Nota</TableCell>
                  <TableCell>Data de Emissão</TableCell>
                  <TableCell>Valor Total</TableCell>
                  <TableCell align="right">Nota Fiscal</TableCell>
                  <TableCell align="right">Nota Fiscal de Serviço</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{notas}</TableBody>
            </Table>
          ) : (
            <p>Não há nenhuma nota fiscal faturada para esse CPF ou CNPJ.</p>
          )}
        </TableContainer>
      </MediaQuery>

      <MediaQuery orientation="portrait">
        {!is_null ? (
          notas_mobile
        ) : (
          <p>Não há nenhuma nota fiscal faturada para esse CPF ou CNPJ.</p>
        )}
      </MediaQuery>
    </React.Fragment>
  );
}

export default Orders;
